import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { TKeycloakUserItem } from 'redux/reducers/accessManagement/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TEmNotificationItem } from '../../../../../redux/reducers/emManagement/types';
import { TBoxStructure } from '../../EasParamsBox/types';

export const tableStructure: TTableStructure<keyof TKeycloakUserItem, TKeycloakUserItem>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Enabled',
		selector: 'enabled',
		noName: true,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.LEFT,
		icons: [
			{
				value: true,
				// icon: { component: AccountCircle, props: { color: 'primary', fontSize: 'small' } },
				icon: EIconButtons.ACCOUNT_CIRCLE,
			},
			{
				value: false,
				// icon: { component: Mail, props: { color: 'error', fontSize: 'small' } },
				icon: EIconButtons.MAIL,
			},
		],
	},
	{
		name: 'User type',
		noName: true,
		selector: 'userType',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.LEFT,
		editable: true,
		icons: [
			{
				value: 'user',
				// icon: { component: AccountCircle, props: { color: 'primary', fontSize: 'small' } },
				icon: EIconButtons.ACCOUNT_CIRCLE,
			},
			{
				value: 'notification email',
				// icon: { component: Mail, props: { color: 'error', fontSize: 'small' } },
				icon: EIconButtons.MAIL,
			},
		],
	},

	{
		name: 'Email',
		selector: 'email',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Username',
		selector: 'username',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},

	{
		name: 'First name',
		selector: 'firstName',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Last name',
		selector: 'lastName',
		editable: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Email verified',
		selector: 'emailVerified',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.RIGHT,
		icons: [
			{
				value: true,
				// icon: { component: CheckCircle, props: { color: 'primary', fontSize: 'small' } },
				icon: EIconButtons.CHECK_CIRCLE,
			},
			{
				value: false,
				// icon: { component: Cancel, props: { color: 'error', fontSize: 'small' } },
				icon: EIconButtons.CANCEL,
			},
		],
	},

	{
		name: 'Created timestamp',
		selector: 'createdTimestamp',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Created at',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Access granted at',
		selector: 'accessGrantedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'id',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{
				name: 'Edit',
				// icon: Edit,
				icon: EIconButtons.EDIT,
			},
		],
		buttonFilter: (item: TKeycloakUserItem) => {
			const buttons: TTableStructureButton[] = [
				{
					name: 'Change notification settings',
					icon: EIconButtons.NOTIFICATION,
					color: 'primary.main',
				},
				{
					name: 'Detach',
					// icon: PersonRemove,
					icon: EIconButtons.PERSON_REMOVE,
					color: 'error.main',
				},
			];
			if (item.userType === 'notification email') {
				buttons.push({ name: 'Enable', icon: EIconButtons.HOW_TO_REG });
			} else {
				buttons.push({ name: 'Reset password', icon: EIconButtons.LOCK_RESET });
			}
			return buttons;
		},
	},
];

export const boxStructure: TBoxStructure<TEmNotificationItem> = {
	title: 'Edit Notification Settings',
	header: [],
	body: [
		{
			name: 'Filed Ioss Oss',
			selector: 'filedIossOss',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Lodge The Oss Quarterly Report',
			selector: 'lodgeTheOssQuarterlyReport',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Lodge The Ioss Report',
			selector: 'lodgeTheIossReport',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Invoice',
			selector: 'invoice',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Outstanding Invoice',
			selector: 'outstandingInvoice',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Update On Vat Correction Status',
			selector: 'updateOnVatCorrectionStatus',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
		{
			name: 'Direct Message',
			selector: 'directMessage',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},
	],
};
